import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/quotationApi";

// Loads the workspace master data needed by the quotation flow in one shot.
export function useMasterData() {
  const [finishes, setFinishes] = useState([]);
  const [masterAccessories, setMasterAccessories] = useState([]);
  const [tierConfigV2, setTierConfigV2] = useState({ tiers: [], modular_multiplier: 2.5 });
  const [paymentPlans, setPaymentPlans] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [f, a, t, pp] = await Promise.all([
          api.get("/finishes"),
          api.get("/accessories"),
          api.get("/settings/tiers-v2"),
          api.get("/settings/payment-plans"),
        ]);
        setFinishes(f.data);
        setMasterAccessories(a.data);
        setTierConfigV2(t.data);
        setPaymentPlans(pp.data?.plans || []);
      } catch {
        toast.error("Failed to load master data");
      }
    })();
  }, []);

  return { finishes, masterAccessories, tierConfigV2, paymentPlans };
}
